angular.module('cvsApp').controller('errorManagerController', ['msgManagerService','getSpecialtyWCMContentService', 'errorModel','webTrendsService','cvsAppData',function(MMS,WCM,EM,WTS,CAD) {
	'use strict';
	var EC = this;
	

	EC[EM.getErrorKey()] = true;
	EC.serviceErrorMessage=CAD.getConstantMessage().serverError;

}]);